/**
 * @generated SignedSource<<de3e9eb8ec3027a3330ada432282e8f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationAppIdResolverQuery$variables = {
  appSlug: string;
  organizationSlug: string;
};
export type OrganizationAppIdResolverQuery$data = {
  readonly viewer: {
    readonly app: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppHeader_app">;
    } | null;
    readonly me: {
      readonly id: string;
    } | null;
  };
};
export type OrganizationAppIdResolverQuery = {
  response: OrganizationAppIdResolverQuery$data;
  variables: OrganizationAppIdResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "me",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "appSlug",
    "variableName": "appSlug"
  },
  {
    "kind": "Variable",
    "name": "organizationSlug",
    "variableName": "organizationSlug"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationAppIdResolverQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AppHeader_app"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrganizationAppIdResolverQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      }
                    ],
                    "type": "User",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e64d4847b674e09b03f18877c7cf22a",
    "id": null,
    "metadata": {},
    "name": "OrganizationAppIdResolverQuery",
    "operationKind": "query",
    "text": "query OrganizationAppIdResolverQuery(\n  $organizationSlug: String!\n  $appSlug: String!\n) {\n  viewer {\n    me {\n      id\n    }\n    app(organizationSlug: $organizationSlug, appSlug: $appSlug) {\n      id\n      ...AppHeader_app\n    }\n  }\n}\n\nfragment AppHeader_app on App {\n  id\n  name\n  slug\n  tenant {\n    __typename\n    ... on Organization {\n      id\n      name\n      slug\n      __typename\n    }\n    ... on User {\n      id\n      email\n      firstName\n      lastName\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c7090511d0fe3b2466d222afd845c14";

export default node;
